import "./App.scss";
import ViewPort from "./Components/ViewPort/ViewPort";
import "./utils/testSentry"; // Import test utilities for development
import "./utils/simpleNetworkTest"; // Import simple network test

function App() {
  return (
    <div className="tp-container">
      {/* <ShoeModel /> */}
      <ViewPort />
    </div>
  );
}

export default App;
